/** Error codes that travel over the wire. Keep stable — clients switch on them. */
export const ERROR_CODES = [
  "BAD_REQUEST",
  "UNAUTHORIZED",
  "FORBIDDEN",
  "NOT_FOUND",
  "MACHINE_OFFLINE",
  "TIMEOUT",
  "PATH_OUTSIDE_WORKSPACE",
  "PATH_OUTSIDE_PROJECT",
  "INVALID_PATH",
  "TOO_LARGE",
  "BINARY_FILE",
  "CONFLICT",
  "ALREADY_EXISTS",
  "INVALID_NAME",
  "RATE_LIMITED",
  "NO_FORMATTER",
  "INTERNAL",
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

/** An error that is safe to report to the remote side (message must not contain secrets/absolute paths). */
export class RaclerError extends Error {
  readonly code: ErrorCode;

  constructor(code: ErrorCode, message: string) {
    super(message);
    this.name = "RaclerError";
    this.code = code;
  }
}

export function isRaclerError(value: unknown): value is RaclerError {
  return value instanceof RaclerError;
}
